/**
 * Lightweight analytics helper. Fires fire-and-forget POSTs to /api/analytics/event.
 *
 * Usage:
 *   import { track } from '@/utils/analytics';
 *   track('sample_clicked', { surface: 'paper_trading_zero_state' });
 *
 * Failure is silent — never disrupts user UX. No third-party SDKs.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'tp360_analytics_session_id';

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `sess_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function getUserEmail() {
  try {
    const raw = localStorage.getItem('tp360_user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u?.email || null;
  } catch {
    return null;
  }
}

export function track(event, properties = {}) {
  if (!API_URL || typeof window === 'undefined') return;
  const payload = {
    event: String(event),
    properties: properties && typeof properties === 'object' ? properties : {},
    session_id: getSessionId(),
    user_email: getUserEmail(),
    path: typeof window !== 'undefined' ? window.location.pathname : null,
  };
  // Use keepalive so events still flush during navigation / unload.
  try {
    fetch(`${API_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* swallowed — never let analytics break product */
  }
}
